<script>

import bem from '@/utils/bem';
import { CloseOutlined, DeleteOutlined, EditOutlined } from '@ant-design/icons-vue';
import columns from '@/pages/settings/faqTemplatesTab/columns';
import { mapActions, mapState } from 'vuex';

const b = bem('faq-template-tab');

export default {
  components: {
    CloseOutlined,
    EditOutlined,
    DeleteOutlined,
  },
  data() {
    return {
      columns: columns(),
      isNewCategory: true,
      selectedCategory: null,
      isShowEditorPopUp: false,
      isShowVariablePopUp: false,
      changeableName: '',
      changeableTitle: '',
      changeableTitleMobile: '',
      changeableDescription: '',
      changeableDescriptionMobile: '',
      changeableId: null,
      variablePopUpNode: null,
    };
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    ...mapActions({
      getTemplatesFAQ: 'faq/getTemplatesFAQ',
      createTemplateFAQ: 'faq/createTemplateFAQ',
      editTemplateFAQ: 'faq/editTemplateFAQ',
      deleteTemplateFAQ: 'faq/deleteTemplateFAQ',
    }),
    openEditor(template) {
      this.isShowEditorPopUp = true;
      if (template) {
        this.changeableName = template.name;
        this.changeableTitle = template.title;
        this.changeableTitleMobile = template.titleMobile;
        this.changeableDescription = template.description;
        this.changeableDescriptionMobile = template.descriptionMobile;
        this.changeableId = template.id;
      }
    },
    onCancel() {
      this.isShowEditorPopUp = false;
      this.changeableTitle = '';
      this.changeableTitleMobile = '';
      this.changeableDescription = '';
      this.changeableDescriptionMobile = '';
      this.changeableId = null;
    },
    onSubmit(value) {
      if (this.changeableId) {
        this.editTemplateFAQ({
          body: value,
          id: this.changeableId,
        });
      } else {
        this.createTemplateFAQ({
          body: value,
        });
      }
      this.onCancel();
    },
    onSubmitForm(formName) {
      this.$formkit.submit(formName);
    },
    onChangeText(value, event) {
      if (value.length >= 2) {
        const subString = value.substr(value.length - 2);
        if (subString === '[[') {
          this.variablePopUpNode = event.context.node;
          this.isShowVariablePopUp = true;
        }
      }
    },
    resetVariablePopUp() {
      this.$formkit.reset('variableLink');
      this.isShowVariablePopUp = false;
      this.variablePopUpNode = null;
    },
    onCloseVariableLink() {
      this.variablePopUpNode.input(this.variablePopUpNode.value.slice(0, -2));
      this.resetVariablePopUp();
    },
    onSaveVariableLink(value) {
      const {
        variableLinkUrl,
        variableLinkText,
      } = value;
      this.variablePopUpNode.input(
        `${this.variablePopUpNode.value}${variableLinkUrl}|${variableLinkText}]]`,
      );
      this.resetVariablePopUp();
    },
    getDescription(description) {
      return description.split('[[')
        .reduce((acc, item) => {
          const [substring = '', continueText = ''] = item.split(']]');
          const [link = '', linkText = ''] = substring.split('|');
          return `${acc}<a href=${link} target="_blank">${linkText}</a>${continueText}`;
        });
    },
  },
  mounted() {
    this.getTemplatesFAQ();
  },
  computed: {
    previewText() {
      return this.getDescription(this.changeableDescription);
    },
    mobilePreviewText() {
      return this.getDescription(this.changeableDescriptionMobile);
    },
    ...mapState({
      faqTemplates: (state) => state.faq.faqTemplates,
      isLoadingTemplates: (state) => state.faq.isLoadingTemplates,
    }),
  },
};
</script>

<template>
  <div :class="b()">
    <div class="create-button">
      <a-button
        type="primary"
        html-type="button"
        @click="openEditor()"
      >
        Add new template
      </a-button>
    </div>

    <a-table
      :columns="columns"
      :data-source="faqTemplates"
      :pagination="false"
      :loading="isLoadingTemplates"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'actions'">
          <div class="actions">
            <a-button
              class="action-button"
              type="primary"
              html-type="button"
              @click="openEditor(record)"
            >
              <EditOutlined /> Edit
            </a-button>
            <a-popconfirm title="Sure to delete?" @confirm="deleteTemplateFAQ(record.id)">
              <a-button
                type="primary"
                html-type="button"
                danger
                class="action-button"
              >
                <DeleteOutlined /> Delete
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </template>
    </a-table>

    <a-modal
      :open="isShowEditorPopUp"
      :footer="null"
      :closable="false"
      width="fit-content"
    >
      <FormKit
        type="form"
        id="faqTemplate"
        @submit="onSubmit"
        :actions="false"
        :form-class="b('editor-form')"
      >
        <a-button
          type="primary"
          danger
          :class="b('close-editor-wrapper')"
          shape="circle"
          size="small"
          @click="onCancel"
        >
          <CloseOutlined/>
        </a-button>
        <FormKit
          type="text"
          name="name"
          v-model="changeableName"
          label="Template Name"
          placeholder="Enter template name"
          validation="required"
          :classes="{
            wrapper: b('input-form-wrapper'),
          }"
        />
        <div :class="b('row')">
          <div :class="b('column')">
            <FormKit
              type="text"
              name="title"
              v-model="changeableTitle"
              label="Question"
              placeholder="Enter Question"
              validation="required"
              :classes="{
                wrapper: b('input-form-wrapper'),
              }"
            />
            <FormKit
              type="textarea"
              name="description"
              v-model="changeableDescription"
              id="descriptionMobileForm"
              @input="onChangeText"
              help="Enter [[ to add a link. To delete a link, erase everything from [[ to ]]"
              label="Answer"
              placeholder="Enter Answer"
              validation="required"
              :classes="{
              wrapper: b('input-form-wrapper'),
            }"
            />
            <div
              :class="b('preview-wrapper')"
              v-if="previewText || changeableTitle"
            >
            <span :class="b('preview-title')">
              {{ changeableTitle }}
            </span>
              <div
                :class="b('preview')"
                v-html="previewText"
              />
            </div>
          </div>
          <div :class="b('column')">
            <FormKit
              type="text"
              name="titleMobile"
              v-model="changeableTitleMobile"
              label="Mobile Question"
              placeholder="Enter Mobile Question"
              :classes="{
              wrapper: b('input-form-wrapper'),
            }"
            />
            <FormKit
              type="textarea"
              name="descriptionMobile"
              v-model="changeableDescriptionMobile"
              id="descriptionMobileForm"
              @input="onChangeText"
              help="Enter [[ to add a link. To delete a link, erase everything from [[ to ]]"
              label="Mobile Answer"
              placeholder="Enter Mobile Answer"
              :classes="{
              wrapper: b('input-form-wrapper'),
            }"
            />
            <div
              :class="b('preview-wrapper')"
              v-if="mobilePreviewText || changeableTitleMobile"
            >
            <span :class="b('preview-title')">
              {{ changeableTitleMobile }}
            </span>
              <div
                :class="b('preview')"
                v-html="mobilePreviewText"
              />
            </div>
          </div>
        </div>
        <a-button
          :class="b('submit-button')"
          @click="() => onSubmitForm('faqTemplate')"
          type="primary"
          size="large"
        >
          {{ changeableId ? "Save" :  "Create" }}
        </a-button>
      </FormKit>
    </a-modal>
    <a-modal
      :open="isShowVariablePopUp"
      @cancel="onCloseVariableLink"
      :closable="false"
      @ok="() => onSubmitForm('variableLink')"
    >
      <FormKit
        type="form"
        id="variableLink"
        @submit="onSaveVariableLink"
        :actions="false"
        :form-class="b('')"
      >
        <FormKit
          type="text"
          name="variableLinkUrl"
          label="Link URL"
          placeholder="Enter link url"
          validation="required"
          :classes="{
          wrapper: b('input-form-wrapper'),
        }"
        />
        <FormKit
          type="text"
          name="variableLinkText"
          label="Link TEXT"
          placeholder="Enter link text"
          validation="required"
          :classes="{
          wrapper: b('input-form-wrapper'),
        }"
        />
      </FormKit>
    </a-modal>
  </div>
</template>

<style scoped lang="scss">
@import "@/styles/media";
@import "@/styles/variables";

.faq-template-tab {

  &__editor-form {
    display: flex;
    flex-direction: column;
    min-height: fit-content;
    padding: 20px 40px;
    gap: 30px;
    width: fit-content;

    @include mediaMinMax(1025, $normal) {
      padding: vw-full(20) vw-full(40);
      gap: vw-full(30);
    }
  }

  &__close-editor-wrapper {
    margin-left: auto;
  }

  &__row {
    display: flex;
    gap: 70px;

    @include mediaMinMax(1025, $normal) {
      gap: vw-full(70);
    }
  }

  &__column {
    display: flex;
    flex-direction: column;
    gap: 20px;
    @include mediaMinMax(1025, $normal) {
      gap: vw-full(20);
    }
  }

  &__preview-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    max-width: 350px;
    box-shadow: 10.1px 12.4px 76px 0 rgba(0, 0, 0, 0.07);
    background-color: #fff;

    @include mediaMinMax(1025, $normal) {
      max-width: vw-full(350);
    }

    &_isCategory {

    }
  }

  &__preview-title {
    padding: 5px;
    font-size: 14px;
    width: 100%;
    display: block;

    &_isCategory {
      background-color: $jagged-ice;
      color: $horizon;
      text-transform: uppercase;
    }
  }

  &__preview {
    padding: 5px;
    color: $main-gray-color;

    &_isCategory {
      color: $ebony-clay-gray-color;
    }
  }

  &__input-form-wrapper {
    min-width: 300px;

    @include mediaMinMax(1025, $normal) {
      min-width: vw-full(300);
    }
  }

  &__submit-button {
    width: fit-content;
    min-width: 100px;
    align-self: flex-end;

    @include mediaMinMax(1025, $normal) {
      min-width: vw-full(100);
    }
  }
}
</style>
